/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


import Sidebar from "../../common/components/Sidebar";
import SideBarContent from "../../common/components/SidebarContent";
import ChatRoomContainer from "./ChatRoomContainer";
import ChatHistoryContainer from "./ChatHistoryContainer";

import {
  clearCurrentConversationId,
  getChatMessages,
  getConversations,
  selectConversation,
  submitChatMessage
} from "./chatMessagesSlice";
import { ChatSection, ConversationSection } from "./components/ChatLayout";

export default function ChatSession() {
    const dispatch = useDispatch();
    const chatMessagesState = useSelector(state => state.chatMessages);
    const [expanded, setExpanded] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Load conversations when component mounts
    useEffect(() => {
        dispatch(getConversations());
    }, [dispatch]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const inputValue = event.target[0].value;
        if (!inputValue.trim() || isSubmitting) return; // Don't submit empty messages or if already submitting

        setIsSubmitting(true);
        try {
            const result = await dispatch(submitChatMessage(inputValue)).unwrap();
            if (result) {
                event.target[0].value = ''; // Clear input after sending
                await dispatch(getConversations()); // Refresh conversations list

                // If this is a new conversation, get the messages
                if (result.conversationId && (!chatMessagesState.currentConversationId || chatMessagesState.currentConversationId !== result.conversationId)) {
                    await dispatch(getChatMessages(result.conversationId));
                }
            }
        } catch (error) {
            console.error('Error submitting message:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSampleQuestionSelected = async (selectedQuestion) => {
        const inputValue = selectedQuestion;
        if (inputValue  && !isSubmitting) {  // Don't submit empty messages or if already submitting
            setIsSubmitting(true);
            try {
                const result = await dispatch(submitChatMessage(inputValue)).unwrap();
                if (result) {
                    await dispatch(getConversations()); // Refresh conversations list

                    // If this is a new conversation, get the messages
                    if (result.conversationId && (!chatMessagesState.currentConversationId || chatMessagesState.currentConversationId !== result.conversationId)) {
                        await dispatch(getChatMessages(result.conversationId));
                    }
                }
            } catch (error) {
                console.error('Error submitting message:', error);
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const handleConversationSelect = async (event) => {
        let conversationResponse = await dispatch(selectConversation(event));
        const conversationId = conversationResponse.payload.id;
        dispatch(getChatMessages(conversationResponse.payload.id));
    };

    const handleNewChat = async () => {
        await dispatch(clearCurrentConversationId());
    };

    const HandleSearchChatHistory = async () => {
        // dispatch(getChatMessages(conversationResponse.payload.id));
    };

    const toggleSidebar = () => {
        setExpanded(!expanded);
    };

    return (
        <main>
            <Sidebar toggleSidebar={toggleSidebar} expanded={expanded}>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <ConversationSection>
                            <ChatHistoryContainer
                                currentConversationId={chatMessagesState.currentConversationId}
                                conversations={chatMessagesState.conversations}
                                handleConversationSelect={handleConversationSelect}
                                handleNewChat={handleNewChat}
                            />
                        </ConversationSection>
                    </Col>
                </Row>
            </Sidebar>
            <SideBarContent expanded={expanded}>
                <ChatSection>
                    <ChatRoomContainer
                        currentConversationId={chatMessagesState.currentConversationId}
                        currentConversationName={chatMessagesState.currentConversationName}
                        isLoading={isSubmitting}
                        messages={chatMessagesState.messages}
                        isTyping={chatMessagesState.isTyping}
                        onSubmit={handleSubmit}
                        onSampleQuestionSelected={handleSampleQuestionSelected}
                    />
                </ChatSection>
            </SideBarContent>
        </main>
    );
}
